import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const benefits = ["REAL client acquisition strategies that don't involve spamming templates everyone saw on YouTube...", 'The business owner mindset shift that took me from Discord communities to CONSISTENT 15-20K months...', 'Behind-the-scenes breakdowns of deals, positioning, and what ACTUALLY works...', 'Daily insights on breaking free from the "copywriter identity" that keeps you from signing retainers...', 'Personal stories and lessons from a broke high school dropout who scaled freelance → agency → M&A...'];
  return <div className="mb-12 sm:mb-16" data-id="element-183">
      <h2 className="text-xl sm:text-2xl font-bold text-white mb-6 text-center" data-id="element-184">
        What You'll Get:
      </h2>
      <div className="space-y-4" data-id="element-185">
        {benefits.map((benefit, index) => <div key={index} className="flex items-start" data-id="element-186">
            <CheckCircleIcon className="h-5 w-5 sm:h-6 sm:w-6 text-[#8AE234] flex-shrink-0 mt-0.5" data-id="element-187" />
            <p className="ml-3 text-gray-300 text-sm sm:text-base" data-id="element-188">{benefit}</p>
          </div>)}
      </div>
    </div>;
}